import { ChanelConfig } from '../../configs/GlobalConfig';
import { getLanguage } from '../../component/helpers/Language';

export const formatTickers = function(tickers) {
  var res = [];
  for (var str of tickers) {
    res.push(formatTickerItem(str));
  }

  return res;
};

export const formatTickerItem = str => {
  var data = str.split('|');
  return formatTickerArray(data);
};

export const formatTickerArray = data => {
  return {
    totalMatchVolume: Number(data[0]),
    marketStatus: data[1],
    tradingDate: new Date(data[2]),
    matchType: Number(data[3]),
    comGroupCode: data[4],
    organCode: data[5],
    ticker: data[6],
    referencePrice: Number(data[7]),
    openPrice: Number(data[8]),
    closePrice: Number(data[9]),
    ceilingPrice: Number(data[10]),
    floorPrice: Number(data[11]),
    highestPrice: Number(data[12]),
    lowestPrice: Number(data[13]),
    matchPrice: Number(data[14]),
    priceChange: Number(data[15]),
    percentPriceChange: Number(data[16]),
    matchVolume: Number(data[17]),
    matchValue: Number(data[18]),
    totalMatchValue: Number(data[19]),
    totalBuyTradeVolume: Number(data[20]),
    totalSellTradeVolume: Number(data[21]),
    dealPrice: Number(data[22]),
    totalDealVolume: Number(data[23]),
    totalDealValue: Number(data[24]),
    foreignBuyVolumeTotal: Number(data[25]),
    foreignBuyValueTotal: Number(data[26]),
    foreignSellVolumeTotal: Number(data[27]),
    foreignSellValueTotal: Number(data[28]),
    foreignTotalRoom: Number(data[29]),
    foreignCurrentRoom: Number(data[30]),
  };
};

export const formatCW = function(cws) {
  var res = [];
  for (var str of cws) {
    res.push(formatCWItem(str));
  }

  return res;
};

export const formatCWItem = str => {
  var data = str.split('|');
  return formatCwArray(data);
};

export const formatCwArray = data => {
  return {
    totalMatchVolume: Number(data[0]),
    marketStatus: data[1],
    tradingDate: new Date(data[2]),
    matchType: Number(data[3]),
    comGroupCode: data[4],
    organCode: data[5],
    ticker: data[6],
    referencePrice: Number(data[7]),
    openPrice: Number(data[8]),
    closePrice: Number(data[9]),
    ceilingPrice: Number(data[10]),
    floorPrice: Number(data[11]),
    highestPrice: Number(data[12]),
    lowestPrice: Number(data[13]),
    matchPrice: Number(data[14]),
    priceChange: Number(data[15]),
    percentPriceChange: Number(data[16]),
    matchVolume: Number(data[17]),
    matchValue: Number(data[18]),
    totalMatchValue: Number(data[19]),
    totalBuyTradeVolume: Number(data[20]),
    totalSellTradeVolume: Number(data[21]),
    dealPrice: Number(data[22]),
    totalDealVolume: Number(data[23]),
    totalDealValue: Number(data[24]),
    foreignBuyVolumeTotal: Number(data[25]),
    foreignBuyValueTotal: Number(data[26]),
    foreignSellVolumeTotal: Number(data[27]),
    foreignSellValueTotal: Number(data[28]),
    foreignTotalRoom: Number(data[29]),
    foreignCurrentRoom: Number(data[30]),
  };
};

export const formatIndexs = function(indexs) {
  var res = [];
  for (var str of indexs) {
    res.push(formatIndexItem(str));
  }

  return res;
};

export const formatIndexItem = str => {
  var data = str.split('|');
  return formatIndexArray(data);
};

export const formatIndexArray = data => {
  return {
    totalMatchVolume: Number(data[0]),
    marketStatus: data[1],
    tradingDate: new Date(data[2]),
    comGroupCode: data[3],
    referenceIndex: Number(data[4]),
    openIndex: Number(data[5]),
    closeIndex: Number(data[6]),
    highestIndex: Number(data[7]),
    lowestIndex: Number(data[8]),
    indexValue: Number(data[9]),
    indexChange: Number(data[10]),
    percentIndexChange: Number(data[11]),
    matchVolume: Number(data[12]),
    matchValue: Number(data[13]),
    totalMatchValue: Number(data[14]),
    totalDealVolume: Number(data[15]),
    totalDealValue: Number(data[16]),
    totalStockUpPrice: Number(data[17]),
    totalStockDownPrice: Number(data[18]),
    totalStockNoChangePrice: Number(data[19]),
    totalStockOverCeiling: Number(data[20]),
    totalStockUnderFloor: Number(data[21]),
    foreignBuyVolumeTotal: Number(data[22]),
    foreignBuyValueTotal: Number(data[23]),
    foreignSellVolumeTotal: Number(data[24]),
    foreignSellValueTotal: Number(data[25]),
    volumeBu: Number(data[26]),
    VolumeSd: Number(data[27]),
  };
};

export const formatSectors = function(sectors) {
  var res = [];
  for (var str of sectors) {
    res.push(formatSectorItem(str));
  }

  return res;
};

export const formatSectorItem = str => {
  var data = str.split('|');
  return formatSectorArray(data);
};

export const formatSectorArray = data => {
  return {
    icbCode: data[0],
    comGroupCode: data[1],
    tradingDate: new Date(data[2]),
    closeIndex: Number(data[3]),
    referenceIndex: Number(data[4]),
    openIndex: Number(data[5]),
    indexChange: Number(data[6]),
    percentIndexChange: Number(data[7]),
    matchVolume: Number(data[8]),
    matchValue: Number(data[9]),
    totalMatchVolume: Number(data[10]),
    totalMatchValue: Number(data[11]),
    totalDealVolume: Number(data[12]),
    totalDealValue: Number(data[13]),
    totalVolume: Number(data[14]),
    totalValue: Number(data[15]),
    dealVolume: Number(data[16]),
    dealValue: Number(data[17]),
    foreignBuyVolumeTotal: Number(data[18]),
    foreignBuyValueTotal: Number(data[19]),
    foreignSellVolumeTotal: Number(data[20]),
    foreignSellValueTotal: Number(data[21]),
    totalStockUpPrice: Number(data[22]),
    totalStockDownPrice: Number(data[23]),
    totalStockNoChangePrice: Number(data[24]),
    totalStockUpCelling: Number(data[25]),
    totalStockDownfloor: Number(data[26]),
    highestIndex: Number(data[27]),
    lowestIndex: Number(data[28]),
  };
};

export const formatDerivatives = function(derivatives) {
  var res = [];

  for (var str of derivatives) {
    res.push(formatDerivativeItem(str));
  }

  return res;
};

export const formatDerivativeItem = str => {
  var data = str.split('|');
  return formatDerivativeArray(data);
};

export const formatDerivativeArray = data => {
  return {
    totalMatchVolume: Number(data[0]),
    marketStatus: data[1],
    tradingDate: new Date(data[2]),
    matchType: Number(data[3]),
    comGroupCode: data[4],
    derivativeCode: data[5],
    referencePrice: Number(data[6]),
    openPrice: Number(data[7]),
    closePrice: Number(data[8]),
    ceilingPrice: Number(data[9]),
    floorPrice: Number(data[10]),
    highestPrice: Number(data[11]),
    lowestPrice: Number(data[12]),
    matchPrice: Number(data[13]),
    priceChange: Number(data[14]),
    percentPriceChange: Number(data[15]),
    matchVolume: Number(data[16]),
    matchValue: Number(data[17]),
    totalMatchValue: Number(data[18]),
    totalBuyTradeVolume: Number(data[19]),
    totalSellTradeVolume: Number(data[20]),
    dealPrice: Number(data[21]),
    totalDealVolume: Number(data[22]),
    totalDealValue: Number(data[23]),
    foreignBuyVolumeTotal: Number(data[24]),
    foreignBuyValueTotal: Number(data[25]),
    foreignSellVolumeTotal: Number(data[26]),
    foreignSellValueTotal: Number(data[27]),
    foreignTotalRoom: Number(data[28]),
    foreignCurrentRoom: Number(data[29]),
    openInterest: Number(data[30]),
  };
};

export const formatBidAsk = function(bidAsks) {
  var res = [];

  for (var str of bidAsks) {
    res.push(formatBidAskItem(str));
  }

  return res;
};

export const formatBidAskItem = str => {
  var data = str.split('|');
  return formatBidAskArray(data);
};

export const formatBidAskArray = data => {
  return {
    comGroupCode: data[0],
    organCode: data[1],
    tradingDate: new Date(data[2]),
    best1Bid: Number(data[3]),
    best1BidVolume: Number(data[4]),
    best2Bid: Number(data[5]),
    best2BidVolume: Number(data[6]),
    best3Bid: Number(data[7]),
    best3BidVolume: Number(data[8]),
    best4Bid: Number(data[9]),
    best4BidVolume: Number(data[10]),
    best5Bid: Number(data[11]),
    best5BidVolume: Number(data[12]),
    best6Bid: Number(data[13]),
    best6BidVolume: Number(data[14]),
    best7Bid: Number(data[15]),
    best7BidVolume: Number(data[16]),
    best8Bid: Number(data[17]),
    best8BidVolume: Number(data[18]),
    best9Bid: Number(data[19]),
    best9BidVolume: Number(data[20]),
    best10Bid: Number(data[21]),
    best10BidVolume: Number(data[22]),
    best11Bid: Number(data[23]),
    best11BidVolume: Number(data[24]),
    best12Bid: Number(data[25]),
    best12BidVolume: Number(data[26]),
    best13Bid: Number(data[27]),
    best13BidVolume: Number(data[28]),
    best14Bid: Number(data[29]),
    best14BidVolume: Number(data[30]),
    best15Bid: Number(data[31]),
    best15BidVolume: Number(data[32]),
    best1Offer: Number(data[33]),
    best1OfferVolume: Number(data[34]),
    best2Offer: Number(data[35]),
    best2OfferVolume: Number(data[36]),
    best3Offer: Number(data[37]),
    best3OfferVolume: Number(data[38]),
    best4Offer: Number(data[39]),
    best4OfferVolume: Number(data[40]),
    best5Offer: Number(data[41]),
    best5OfferVolume: Number(data[42]),
    best6Offer: Number(data[43]),
    best6OfferVolume: Number(data[44]),
    best7Offer: Number(data[45]),
    best7OfferVolume: Number(data[46]),
    best8Offer: Number(data[47]),
    best8OfferVolume: Number(data[48]),
    best9Offer: Number(data[49]),
    best9OfferVolume: Number(data[50]),
    best10Offer: Number(data[51]),
    best10OfferVolume: Number(data[52]),
    best11Offer: Number(data[53]),
    best11OfferVolume: Number(data[54]),
    best12Offer: Number(data[55]),
    best12OfferVolume: Number(data[56]),
    best13Offer: Number(data[57]),
    best13OfferVolume: Number(data[58]),
    best14Offer: Number(data[59]),
    best14OfferVolume: Number(data[60]),
    best15Offer: Number(data[61]),
    best15OfferVolume: Number(data[62]),
  };
};

const unique = (items, field) => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.reduce((result, item) => {
    const existIndex = result.findIndex(it => it[field] === item[field]);
    if (existIndex !== -1) {
      result[existIndex] = item;

      return result;
    }
    result.push(item);

    return result;
  }, []);
};

export const formatMessageData = (channel, data) => {
  //heat map - map language
  if (channel.indexOf('HeatMap') > -1) {
    const lang = getLanguage();
    switch (lang) {
      case 'en':
        data.sectors.forEach(el => {
          el.name = el.en_Name;
          if (el.tickers) {
            el.tickers.forEach(t => {
              t.name = t.en_Name;
            });
          }
        });
        break;
      case 'ja':
        data.sectors.forEach(el => {
          el.name = el.jp_Name;
          if (el.tickers) {
            el.tickers.forEach(t => {
              t.name = t.jp_Name;
            });
          }
        });
        break;
      default:
        break;
    }
  }

  switch (channel) {
    case ChanelConfig.TickChanel:
      return formatTickers(data);
    case ChanelConfig.IndexChannel:
      return formatIndexs(data);
    case ChanelConfig.DerivativeChannel:
      return formatDerivatives(data);
    case ChanelConfig.BidAskChannel:
      return formatBidAsk(data);
    case ChanelConfig.CoveredWarrantChannel:
      return formatCW(data);
    case ChanelConfig.SectorChanel:
      return formatSectors(data);
    default:
      return data;
  }
};

export const STOCK = 0;
export const INDEX = 1;
export const DERIVATIVE = 2;
export const BIDASK = 3;
export const SECTOR = 4;
export const convertNumber = str => {
  return Number(str);
};

export const convertMarketStatus = str => {
  switch (Number(str)) {
    case 1:
      return 'ATO';
    case 2:
      return 'ATO_OPEN';
    case 3:
      return 'ATO_CLOSE';
    case 4:
      return 'ATC';
    case 5:
      return 'ATC_OPEN';
    case 6:
      return 'ATC_CLOSE';
    default:
      return '';
  }
};

export const EIGHT = new Date().setHours(8, 0, 0, 0);
export const convertTradingDate = str => {
  return new Date(EIGHT + Number(str) * 1000);
};

export const SpecialStrings = {
  UPCOM: 'UpcomIndex',
};
export const convertString = str => {
  var res = '';
  const s = res + str;
  for (var i = 0; i < s.length; i += 2) {
    res += String.fromCharCode(Number(s.substring(i, i + 2)) + 28);
  }

  if (SpecialStrings[res]) {
    return SpecialStrings[res];
  }

  return res;
};

export const convertNone = input => {
  return input;
};

export const StockConverters = [
  convertNone,
  convertMarketStatus,
  convertTradingDate,
  convertNone,
  convertString,
  convertString,
  convertString,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
];

export const StockFieldIndex = {
  totalMatchVolume: 0,
  tradingDate: 2,
  referencePrice: 7,
  matchPrice: 14,
  priceChange: 15,
  percentPriceChange: 16,
  matchVolume: 17,
  matchValue: 18,
  totalMatchValue: 19,
};

export const StockFields = [
  'totalMatchVolume',
  'marketStatus',
  'tradingDate',
  'matchType',
  'comGroupCode',
  'organCode',
  'ticker',
  'referencePrice',
  'openPrice',
  'closePrice',
  'ceilingPrice',
  'floorPrice',
  'highestPrice',
  'lowestPrice',
  'matchPrice',
  'priceChange',
  'percentPriceChange',
  'matchVolume',
  'matchValue',
  'totalMatchValue',
  'totalBuyTradeVolume',
  'totalSellTradeVolume',
  'dealPrice',
  'totalDealVolume',
  'totalDealValue',
  'foreignBuyVolumeTotal',
  'foreignBuyValueTotal',
  'foreignSellVolumeTotal',
  'foreignSellValueTotal',
  'foreignTotalRoom',
  'foreignCurrentRoom',
];

export const IndexConverters = [
  convertNone,
  convertMarketStatus,
  convertTradingDate,
  convertString,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
];

export const IndexFieldIndex = {
  totalMatchVolume: 0,
  tradingDate: 2,
  referenceIndex: 4,
  indexValue: 9,
  indexChange: 10,
  percentIndexChange: 11,
  matchVolume: 12,
  matchValue: 13,
  totalMatchValue: 14,
};

export const IndexFields = [
  'totalMatchVolume',
  'marketStatus',
  'tradingDate',
  'comGroupCode',
  'referenceIndex',
  'openIndex',
  'closeIndex',
  'highestIndex',
  'lowestIndex',
  'indexValue',
  'indexChange',
  'percentIndexChange',
  'matchVolume',
  'matchValue',
  'totalMatchValue',
  'totalDealVolume',
  'totalDealValue',
  'totalStockUpPrice',
  'totalStockDownPrice',
  'totalStockNoChangePrice',
  'totalStockOverCeiling',
  'totalStockUnderFloor',
  'foreignBuyVolumeTotal',
  'foreignBuyValueTotal',
  'foreignSellVolumeTotal',
  'foreignSellValueTotal',
  'volumeBu',
  'VolumeSd',
];

export const DerivativeConverters = [
  convertNone,
  convertMarketStatus,
  convertTradingDate,
  convertNone,
  convertString,
  convertString,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
];

export const DerivativeFieldIndex = {
  totalMatchVolume: 0,
  tradingDate: 2,
  referencePrice: 6,
  matchPrice: 13,
  priceChange: 14,
  percentPriceChange: 15,
  matchVolume: 16,
  matchValue: 17,
  totalMatchValue: 18,
};

export const DerivativeFields = [
  'totalMatchVolume',
  'marketStatus',
  'tradingDate',
  'matchType',
  'comGroupCode',
  'derivativeCode',
  'referencePrice',
  'openPrice',
  'closePrice',
  'ceilingPrice',
  'floorPrice',
  'highestPrice',
  'lowestPrice',
  'matchPrice',
  'priceChange',
  'percentPriceChange',
  'matchVolume',
  'matchValue',
  'totalMatchValue',
  'totalBuyTradeVolume',
  'totalSellTradeVolume',
  'dealPrice',
  'totalDealVolume',
  'totalDealValue',
  'foreignBuyVolumeTotal',
  'foreignBuyValueTotal',
  'foreignSellVolumeTotal',
  'foreignSellValueTotal',
  'foreignTotalRoom',
  'foreignCurrentRoom',
  'openInterest',
];

export const BidAskConverter = [
  convertString,
  convertString,
  convertTradingDate,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
];

export const BidAskFields = [
  'comGroupCode',
  'organCode',
  'tradingDate',
  'best1Bid',
  'best1BidVolume',
  'best2Bid',
  'best2BidVolume',
  'best3Bid',
  'best3BidVolume',
  'best4Bid',
  'best4BidVolume',
  'best5Bid',
  'best5BidVolume',
  'best6Bid',
  'best6BidVolume',
  'best7Bid',
  'best7BidVolume',
  'best8Bid',
  'best8BidVolume',
  'best9Bid',
  'best9BidVolume',
  'best10Bid',
  'best10BidVolume',
  'best11Bid',
  'best11BidVolume',
  'best12Bid',
  'best12BidVolume',
  'best13Bid',
  'best13BidVolume',
  'best14Bid',
  'best14BidVolume',
  'best15Bid',
  'best15BidVolume',
  'best1Offer',
  'best1OfferVolume',
  'best2Offer',
  'best2OfferVolume',
  'best3Offer',
  'best3OfferVolume',
  'best4Offer',
  'best4OfferVolume',
  'best5Offer',
  'best5OfferVolume',
  'best6Offer',
  'best6OfferVolume',
  'best7Offer',
  'best7OfferVolume',
  'best8Offer',
  'best8OfferVolume',
  'best9Offer',
  'best9OfferVolume',
  'best10Offer',
  'best10OfferVolume',
  'best11Offer',
  'best11OfferVolume',
  'best12Offer',
  'best12OfferVolume',
  'best13Offer',
  'best13OfferVolume',
  'best14Offer',
  'best14OfferVolume',
  'best15Offer',
  'best15OfferVolume',
];

export const SectorConverters = [
  convertString,
  convertString,
  convertTradingDate,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
  convertNone,
];

export const SectorFieldIndex = {
  totalMatchVolume: 0,
  tradingDate: 2,
  referenceIndex: 4,
  indexValue: 9,
  indexChange: 10,
  percentIndexChange: 11,
  matchVolume: 12,
  matchValue: 13,
  totalMatchValue: 14,
};

export const SectorFields = [
  'icbCode',
  'comGroupCode',
  'tradingDate',
  'closeIndex',
  'referenceIndex',
  'openIndex',
  'indexChange',
  'percentIndexChange',
  'matchVolume',
  'matchValue',
  'totalMatchVolume',
  'totalMatchValue',
  'totalDealVolume',
  'totalDealValue',
  'totalVolume',
  'totalValue',
  'dealVolume',
  'dealValue',
  'foreignBuyVolumeTotal',
  'foreignBuyValueTotal',
  'foreignSellVolumeTotal',
  'foreignSellValueTotal',
  'totalStockUpPrice',
  'totalStockDownPrice',
  'totalStockNoChangePrice',
  'totalStockUpCelling',
  'totalStockDownFloor',
  'highestIndex',
  'lowestIndex',
];
